export default __webpack_public_path__ + "e6335633a5ba43728054a9fb8cb0bc08.png";